import { OrderTypeModalCallable } from 'app/_authenticated/trade/components/OrderTypeModal/OrderTypeModal';
import { InfoModalCallable } from 'components/InfoModal/InfoModal';

export function CallableRoot() {
  return (
    <>
      <OrderTypeModalCallable.Root />
      <InfoModalCallable.Root />
    </>
  );
}
